import React from 'react';
import { Box, Heading, BoxProps, HeadingProps } from '@landr/maestro';
import { css } from '@landr/styled-system/css';

const wrapperStyles = css({
    '& [data-generic-carousel-heading]': {
        fontSize: 'md',
        md: {
            fontSize: 'base',
        },
    },
});

const headerStyles = css({
    marginBottom: 'lg',
    fontSize: '2xl',
    md: {
        fontSize: '2xl',
        marginBottom: 'xs',
    },
});

export const CollectionDetailsCarouselWrapper = ({
    children,
    ...props
}: BoxProps) => (
    <Box className={wrapperStyles} {...props}>
        {children}
    </Box>
);

export const CollectionDetailsHeader = ({
    children,
    ...props
}: HeadingProps) => (
    <Heading className={headerStyles} {...props}>
        {children}
    </Heading>
);
